import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { ILevel } from 'src/app/interfaces/resource';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-program-form',
  templateUrl: './program-form.component.html',
  styleUrls: ['./program-form.component.scss']
})
export class ProgramFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
   @ViewChild('photoFile',{static:false}) photoFile: ElementRef;

  ITEM_KEY: any;
  ITEM: ILevel;
  TITLE: any = "Add new program"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;
  START_UPLOAD: boolean;
  uploadPercent: any;
  SELECTED_PICTURE_FILE: any;
  imageSrc: string;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: ResourceStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.PROGRAM, "name")],
      description: [null],
    })
    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData(COLLECTION_NAME.PROGRAM, this.ITEM_KEY, (doc: any) => {
          if (doc) {
            this.TITLE = "Edit program"
            this.ITEM = doc;
            this.form = this.fb.group({
              name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.PROGRAM, "name", this.ITEM.name)],
              description: [null],
            })
            const { name, description } = doc;
            this.form.patchValue({
              name, description
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/programs`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
      }
    })
  }


  async uploadFilePicture(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_PICTURE_FILE = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      if (this.ITEM) {
        //PICTURE
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `programs/${this.ITEM.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        this.ITEM.coverFileDetail = files;
        this.store.addItem(COLLECTION_NAME.PROGRAM, this.ITEM, (success, res) => {
          if (success) {
            this.snackBar.open("Program has been saved successful.", "Done", { duration: 2500 });
          }
          this.processNew = false;
          this.processClose = false;
          this.SELECTED_PICTURE_FILE = null;
          this.START_UPLOAD = false;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
        })
      }
    }
  }


  async onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      this.form.disable();
      const { name, description,price } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const item: ILevel = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key:this.ITEM?this.ITEM.page_key:ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        coverFileDetail: this.ITEM ? this.ITEM.coverFileDetail : null,
      }
      if (this.SELECTED_PICTURE_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `programs/${item.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        item.coverFileDetail = files;
        this.START_UPLOAD = false;
      }
      this.store.addItem(COLLECTION_NAME.PROGRAM, item, (success, res) => {
        if (success) {
          this.snackBar.open("Program has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.imageSrc = null;
        this.SELECTED_PICTURE_FILE = null;
        this.photoFile.nativeElement.value = "";
        this.inputEl.nativeElement.focus();
        if (this.ITEM_KEY) {
          const status = isDraft ? 'draft' : 'submitted'
          this.router.navigate([`/programs/${status}`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    let status = 'submitted';
    // if (this.ITEM) {
    //   status = this.ITEM.register_status.router
    // }
    this.router.navigate([`/programs/${status}`])
  }

}
